import classNames from "classnames";
import css from "PFApp/booking/parts/overview/detail_view/detail_view.module.scss";
import { ReadableAvailabilityRules } from "PFApp/components/readable_availability_rules";
import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useReadableAvailability } from "PFCore/helpers/use_readable_availability";
import { AvailabilityRule } from "PFTypes";
import { useTranslation } from "react-i18next";

import { Label } from "../parts/label";

type DurationProps = { availability: AvailabilityRule };

export const Duration = ({ availability }: DurationProps) => {
  const { t } = useTranslation();

  const { readableAvailability } = useReadableAvailability({
    availability: availability as AvailabilityRule
  });

  return (
    <span className={classNames(css.item, css.duration)}>
      <span>
        <Flex alignItems="center" gap="spacingSm">
          <Label icon="calendar" text={t("duration")} />
          {availability?.ranges && (
            <Tooltip
              content={
                <div className={css.availabilityTooltip}>
                  <ReadableAvailabilityRules availability={availability} />
                </div>
              }
              triggerContainerProps={{
                className: css.alignCenter
              }}
            >
              <Icon name="info" size="sm" color="paletteBlue0" />
            </Tooltip>
          )}
        </Flex>
        <Typography variant="bodyBold">{readableAvailability}</Typography>
      </span>
    </span>
  );
};
